var map = {
	"./ATM.vue": [
		37700,
		7700
	],
	"./admin-menu.vue": [
		88810,
		8810
	],
	"./agent.vue": [
		90343,
		343
	],
	"./arrow mini.vue": [
		26704,
		6704
	],
	"./arrow transfer.vue": [
		25554,
		5554
	],
	"./arrow-down-2.vue": [
		62707,
		2707
	],
	"./arrow-down-left.vue": [
		67440,
		7440
	],
	"./arrow-down.vue": [
		48707,
		8707
	],
	"./arrow-left.vue": [
		29420,
		9420
	],
	"./arrow-up-2.vue": [
		82940,
		2940
	],
	"./arrow-up-down.vue": [
		87384,
		7384
	],
	"./arrow-up-right.vue": [
		35776,
		5776
	],
	"./arrow-up.vue": [
		7050,
		7050
	],
	"./arrow.vue": [
		16709,
		6709
	],
	"./assets.vue": [
		45069,
		5069
	],
	"./banknote.vue": [
		64793,
		4793
	],
	"./bell-dot.vue": [
		1998,
		1998
	],
	"./bell.vue": [
		12042,
		2042
	],
	"./bot-message.vue": [
		84238,
		4238
	],
	"./burger.vue": [
		48244,
		8244
	],
	"./calendar.vue": [
		26583,
		6583
	],
	"./cancel-bg-red.vue": [
		88655,
		8655
	],
	"./card.vue": [
		65756,
		5756
	],
	"./check-green-bg.vue": [
		26938,
		6938
	],
	"./check-green.vue": [
		30307,
		307
	],
	"./check-mark.vue": [
		56161,
		6161
	],
	"./chevron-down.vue": [
		43775,
		3775
	],
	"./chevron-left.vue": [
		38608,
		8608
	],
	"./chevron-right.vue": [
		57889,
		7889
	],
	"./chevron-up-down.vue": [
		60614,
		614
	],
	"./chevron-up.vue": [
		31089,
		1089
	],
	"./circle-progress.vue": [
		53570,
		1189
	],
	"./circle-x.vue": [
		28607,
		8607
	],
	"./clear-search.vue": [
		42664,
		283
	],
	"./clip-files.vue": [
		71775,
		1775
	],
	"./clock.vue": [
		98206,
		8206
	],
	"./close.vue": [
		65701,
		5701
	],
	"./coins-pair.vue": [
		96386,
		6386
	],
	"./coins.vue": [
		29492,
		9492
	],
	"./copy.vue": [
		72070,
		2070
	],
	"./crypto-ADA.vue": [
		73789,
		3789
	],
	"./crypto-ALGO.vue": [
		63969,
		3969
	],
	"./crypto-APT.vue": [
		2786,
		2786
	],
	"./crypto-ARB.vue": [
		98763,
		8763
	],
	"./crypto-AVAX.vue": [
		83238,
		3238
	],
	"./crypto-BASE.vue": [
		18622,
		8622
	],
	"./crypto-BCH.vue": [
		62012,
		2012
	],
	"./crypto-BSC.vue": [
		66083,
		6083
	],
	"./crypto-BSV.vue": [
		60167,
		167
	],
	"./crypto-BTC.vue": [
		15901,
		5901
	],
	"./crypto-DOGE.vue": [
		93686,
		3686
	],
	"./crypto-DOT.vue": [
		49278,
		9278
	],
	"./crypto-ETC.vue": [
		21368,
		1368
	],
	"./crypto-ETH.vue": [
		39140,
		9140
	],
	"./crypto-LTC.vue": [
		29141,
		9141
	],
	"./crypto-MATIC.vue": [
		22364,
		2364
	],
	"./crypto-NEAR.vue": [
		41701,
		1701
	],
	"./crypto-OP.vue": [
		26910,
		6910
	],
	"./crypto-SOL.vue": [
		10947,
		947
	],
	"./crypto-TON.vue": [
		4288,
		4288
	],
	"./crypto-TRX.vue": [
		81381,
		1381
	],
	"./crypto-TetherOMNI.vue": [
		43898,
		3898
	],
	"./crypto-XLM.vue": [
		26769,
		6769
	],
	"./crypto-XRP.vue": [
		92142,
		2142
	],
	"./crypto-XTZ.vue": [
		18976,
		8976
	],
	"./crypto-ZEC.vue": [
		85715,
		5715
	],
	"./cryptocurr-new.vue": [
		54788,
		4788
	],
	"./cryptocurr.vue": [
		10144,
		144
	],
	"./data.vue": [
		41000,
		1000
	],
	"./default-curr.vue": [
		80764,
		764
	],
	"./deposit.vue": [
		27042,
		7042
	],
	"./double-check.vue": [
		98432,
		8432
	],
	"./download-file.vue": [
		5318,
		5318
	],
	"./echeck-new.vue": [
		40785,
		785
	],
	"./echeck.vue": [
		15830,
		5830
	],
	"./edit.vue": [
		57446,
		7446
	],
	"./edit_k.vue": [
		5555,
		5555
	],
	"./edit_va.vue": [
		7995,
		7995
	],
	"./ellipsis.vue": [
		77584,
		7584
	],
	"./empty-uploader.vue": [
		23006,
		3006
	],
	"./error.vue": [
		97199,
		7199
	],
	"./eshop.vue": [
		78741,
		8741
	],
	"./exchange.vue": [
		81892,
		1892
	],
	"./export.vue": [
		70357,
		357
	],
	"./external-link.vue": [
		51547,
		1547
	],
	"./external.vue": [
		31263,
		1263
	],
	"./eye-dollar.vue": [
		56381,
		6381
	],
	"./eye-off.vue": [
		99975,
		9975
	],
	"./eye.vue": [
		73221,
		3221
	],
	"./fallback-circle.vue": [
		14669
	],
	"./feedback.vue": [
		49145,
		9145
	],
	"./file-question.vue": [
		8100,
		8100
	],
	"./file-text.vue": [
		28195,
		8195
	],
	"./filter-select-clear.vue": [
		63578,
		3578
	],
	"./filter.vue": [
		72509,
		4890
	],
	"./full-table.vue": [
		78499,
		8499
	],
	"./gears.vue": [
		43678,
		3678
	],
	"./globe.vue": [
		92879,
		2879
	],
	"./hand-coins.vue": [
		9433,
		9433
	],
	"./hashtag.vue": [
		7293,
		7293
	],
	"./history.vue": [
		37571,
		7571
	],
	"./horizontal_arr.vue": [
		85558,
		5558
	],
	"./iconname.vue": [
		3810,
		3810
	],
	"./info.vue": [
		38684,
		8684
	],
	"./inform-auth.vue": [
		91017,
		1017
	],
	"./inform-card.vue": [
		68029,
		8029
	],
	"./inform-income.vue": [
		21551,
		1551
	],
	"./inform-mail.vue": [
		76437,
		6437
	],
	"./inform-outcome.vue": [
		99813,
		9813
	],
	"./inform-payrequest.vue": [
		92183,
		2183
	],
	"./inform-security.vue": [
		82814,
		2814
	],
	"./key-round.vue": [
		96674,
		6674
	],
	"./key.vue": [
		56790,
		6790
	],
	"./like.vue": [
		284,
		284
	],
	"./link.vue": [
		72978,
		2978
	],
	"./linkedin.vue": [
		9954,
		9954
	],
	"./list-restart.vue": [
		46667,
		6667
	],
	"./lng.vue": [
		90228,
		228
	],
	"./lock-open.vue": [
		38254,
		8254
	],
	"./lock.vue": [
		67573,
		7573
	],
	"./logout.vue": [
		61850,
		1850
	],
	"./mail-check.vue": [
		25844,
		5844
	],
	"./mail.vue": [
		91340,
		1340
	],
	"./masspay-new.vue": [
		78383,
		8383
	],
	"./masspay.vue": [
		9404,
		9404
	],
	"./message-send.vue": [
		70530,
		530
	],
	"./minus.vue": [
		3953,
		3953
	],
	"./money-bag.vue": [
		76888,
		6888
	],
	"./money.vue": [
		8658,
		8658
	],
	"./money_burn.vue": [
		19945,
		9945
	],
	"./name.vue": [
		20453,
		453
	],
	"./notify.vue": [
		11016,
		1016
	],
	"./order support.vue": [
		99430,
		9430
	],
	"./orders.vue": [
		7858,
		7858
	],
	"./p2p-new.vue": [
		73269,
		3269
	],
	"./p2p.vue": [
		6637,
		6637
	],
	"./password.vue": [
		9631,
		9631
	],
	"./pay-new.vue": [
		72838,
		2838
	],
	"./pay.vue": [
		25937,
		5937
	],
	"./pencil.vue": [
		31358,
		1358
	],
	"./phone.vue": [
		23612,
		3612
	],
	"./plus.vue": [
		19405,
		9405
	],
	"./question.vue": [
		75273,
		5273
	],
	"./rates.vue": [
		45424,
		5424
	],
	"./receipt-text.vue": [
		59927,
		9927
	],
	"./refresh.vue": [
		81175,
		1175
	],
	"./repeat.vue": [
		20117,
		117
	],
	"./search-grey.vue": [
		2680,
		2680
	],
	"./search-select.vue": [
		35359,
		5359
	],
	"./search.vue": [
		82399,
		2399
	],
	"./settings.vue": [
		6166,
		6166
	],
	"./shield.vue": [
		82541,
		2541
	],
	"./star-outline.vue": [
		57709,
		7709
	],
	"./star.vue": [
		92062,
		9681
	],
	"./store.vue": [
		40812,
		812
	],
	"./support.vue": [
		97826,
		7826
	],
	"./table.vue": [
		88885,
		8885
	],
	"./template-new.vue": [
		29323,
		9323
	],
	"./template.vue": [
		13834,
		3834
	],
	"./test-coin.vue": [
		69764,
		9764
	],
	"./test.vue": [
		80737,
		737
	],
	"./text.vue": [
		17197,
		7197
	],
	"./time-is-up.vue": [
		1814,
		1814
	],
	"./timeline-time-is-up-mobile.vue": [
		39382,
		9382
	],
	"./timeline-time-is-up.vue": [
		82852,
		2852
	],
	"./tools.vue": [
		98075,
		8075
	],
	"./trash-p2p.vue": [
		19802,
		9802
	],
	"./trash.vue": [
		62062,
		2062
	],
	"./undo.vue": [
		65717,
		5717
	],
	"./update.vue": [
		63834,
		1453
	],
	"./uploader.vue": [
		85617,
		7998
	],
	"./user.vue": [
		63930,
		1549
	],
	"./va-facebook.vue": [
		65989,
		5989
	],
	"./va-host.vue": [
		54058,
		4058
	],
	"./va-mail.vue": [
		93263,
		3263
	],
	"./va-telegram.vue": [
		65092,
		5092
	],
	"./va-twitter.vue": [
		31189,
		3570
	],
	"./va-white-book.vue": [
		4839,
		4839
	],
	"./va.vue": [
		41078,
		1078
	],
	"./verify.vue": [
		80743,
		743
	],
	"./wallet.vue": [
		86490,
		6490
	],
	"./wand.vue": [
		32897,
		2897
	],
	"./warning-info.vue": [
		63912,
		3912
	],
	"./warning-keyt.vue": [
		80725,
		725
	],
	"./warning-money.vue": [
		80039,
		39
	],
	"./whatsapp.vue": [
		47710,
		7710
	],
	"./withdraw.vue": [
		56537,
		6537
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40259;
module.exports = webpackAsyncContext;